"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mediaQueries = exports.getMediaQueries = exports.breakpointsInPx = exports.aliasBreakpoints = void 0;
var getMediaQueries = function getMediaQueries(theme) {
  var mediaQueries = theme.mediaQueries;
  return mediaQueries;
};
exports.getMediaQueries = getMediaQueries;
var breakpoints = ['640px', '769px', '1201px', '1441px'];
var breakpointsInPx = {
  sm: 0,
  "default": 0,
  md: 768,
  lg: 1200,
  xl: 1440
};
exports.breakpointsInPx = breakpointsInPx;
var aliasBreakpoints = {
  // sm: '',
  // default: '',
  md: breakpoints[1],
  // md: '48rem',
  lg: breakpoints[2],
  // lg: '64rem',
  xl: breakpoints[3]
};
exports.aliasBreakpoints = aliasBreakpoints;
var mediaQueries = {
  small: "@media screen and (max-width : ".concat(aliasBreakpoints.md, ")"),
  medium: "@media screen and (min-width : ".concat(aliasBreakpoints.md, ")"),
  large: "@media screen and (min-width : ".concat(aliasBreakpoints.lg, ")"),
  xlarge: "@media screen and (min-width : ".concat(aliasBreakpoints.xl, ")"),
  min: function min(value) {
    return "@media screen and (min-width : ".concat(value, "px)");
  },
  max: function max(value) {
    return "@media screen and (max-width : ".concat(value, "px)");
  }
};
exports.mediaQueries = mediaQueries;